import { Platform, View } from 'react-native';
import { clsx } from 'clsx';
import { Props, Post, Paginator, Tag } from 'shared/@types';
import { apiRoute } from 'shared/library/api-route';
import { H1 } from 'shared/components/title';
import { PostCard } from 'shared/components/post-card';
import { Pagination } from 'shared/components/pagination';
import { PageBuilder } from 'shared/library/page-builder';

interface ShowTagScreenProps extends Props {
  tag: Tag;
  posts: Paginator<Post>;
}

const ShowTagScreen = ({ tag, posts }: ShowTagScreenProps) => {
  return (
    <View className={clsx('p-3 md:p-6 md:py-12', Platform.OS !== 'web' && 'min-h-0 flex-1')}>
      <View
        className={clsx(
          'mx-auto w-full max-w-screen-xl',
          Platform.OS !== 'web' && 'min-h-0 flex-1',
        )}
      >
        <Pagination
          showAds={true}
          paginator={posts}
          renderItem={(post) => <PostCard key={post.id} post={post} />}
          ListHeader={() => (
            <H1
              title={tag.name}
              subtitle={tag.description}
              center={true}
              hideTitleWhenNativeHeader={true}
            />
          )}
        />
      </View>
    </View>
  );
};

ShowTagScreen.pageBuilder = new PageBuilder<ShowTagScreenProps, { tag: string; page: string }>()
  .request(({ req, params }) =>
    req<{ tag: Tag; posts: Paginator<Post> }>(apiRoute('tags.show', { tag: params.tag }), {
      page: params.page,
    }),
  )
  .deriveRouteParams((props) => ({
    tag: props.tag.slug,
  }));

export { ShowTagScreen };
export type { ShowTagScreenProps };
